








































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { CriiptoStatus } from '../../types/enums/criipto-status';
import type { Id } from '../../types/eid';
import { EidType } from '../../types/enums/eid-type';
import MitId from '../../assets/mitid.svg';

export default defineComponent({
  components: {
    MitId,
  },
  props: {
    status: {
      type: String as PropType<CriiptoStatus>,
      required: true,
    },
    selectedEid: {
      type: Object as PropType<Id>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isDisabled = computed((): boolean => [CriiptoStatus.Loading].includes(props.status));

    const handleClick = (): void => {
      emit('sign');
    };

    return { isDisabled, handleClick, CriiptoStatus, EidType };
  },
});
